export default __webpack_public_path__ + "static/media/spotify.47654cd9.png";